import type { ClientContext } from '../../types'

/**
 * Documentation: https://www.notion.so/circuit/B2B-Firebase-Functions-b98eb289350e4c3ea9115fe5d2c9e677#e1e0c1d5ecb642859fe1604b1836e700
 * */
export function updateStripeSubscription(
  context: ClientContext,
  {
    teamId,
    paymentId,
    subscriptions,
  }: {
    teamId: string
    paymentId?: string
    subscriptions?: string[]
  },
) {
  return context.request(`/teams/${teamId}/subscriptions`, {
    method: 'PATCH',
    withAuth: true,
    json: {
      paymentId,
      subscriptions,
    },
  })
}
